import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import writeXlsxFile from 'write-excel-file';

const DEFAULT_OPTIONS = {
  fileName: 'MySpreadsheet', // Name of the resulting spreadsheet
  extraLength: 3, // A bigger number means that columns will be wider
  writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
  writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
  RTL: false // Display the columns from right-to-left (the default value is false)
};

@Injectable()
export class XlsxService {
  private options: any;
  private data: any;

  constructor(private translate: TranslateService) {}

  public dataToXlsx(sourceData: any, fileName: string, options = {}) {
    this.data = sourceData;
    this.options = { ...DEFAULT_OPTIONS, ...options };
    if (fileName) {
      this.options.fileName = fileName;
    }
    const content = this.data.map((data) => data.content);
    const sheets = this.data.map((data) => data.sheet);
    const schema = this.data.map((data) => data.schema);
    writeXlsxFile(content, {
      schema,
      sheets,
      fileName: this.options.fileName
    });
  }
}
